export const language = {
  "default":"TR",
  "TR":{
    "name":"Türkçe",
    "alias":"turkish",
    "short":"TR",
    "keywords": {
      "home":"ANASAYFA",
      "aboutUs":"HAKKIMIZDA",
      "findExpert":"UZMAN BUL",
      "ourEducations":"Eğitimlerimiz",
      "articles":"BLOG",
      "contactUs":"İLETİŞİM",
      "signIn":"GİRİŞ YAPIN",
      "signUp":"KATILIM",
      "keyword":"Anahtar Kelime",
      "sector":"Sektör",
      "profession":"Uzmanlık Alanı",
      "regionOfInterest":"İlgilendiği Bölge",
      "language":"Dil",
      "wantToJoinToOurExperts":"Uzmanlarımız arasına katılmak ister misiniz ?",
      "slogan1":"SEN OL Kİ MEDYANIN SESİ TAM OLSUN",
      "watchPromotionVideo":"Tanıtım videosunu izle",
      "wantToRecommendExpert":"Uzman önermek ister misiniz ?",
      "findWomanExpert":"Kadın Uzman Bulun",
      "pleaseSelectSector":"Lütfen bir sektör seçin",
      "pleaseSelectProfession":"Lütfen bir uzmanlık alanı seçin",
      "pleaseSelectRegion":"Lütfen bir bölge seçiniz",
      "pleaseSelectLanguage":"Lütfen bir dil seçiniz",
      "upcomingEducations":"Yaklaşan Eğitimler",
      "upcoming":"Yaklaşan",
      "educations":"Eğitimler",
      "featured":"Öne Çıkan",
      "lastJoined":"Son Katılan",
      "experts":"Uzmanlar",
      "lastJoinedExperts":"Son Katılan Uzmanlar",
      "getInTouch":"İletişime Geç",
      "recent":"Son Yapılan",
      "posts":"Paylaşımlar",
      "ourSponsors":"Sponsorlarımız",
      "ourSupporters":"Destekçilerimiz",
      "profile":"BİLGİLERİM",
      "messages":"Mesajlar",
      "egitimler":"EĞİTİMLER",
      "toplantilar":"TOPLANTILAR",
      "farkindalikCalismalari":"FARKINDALIK ÇALIŞMALARI",
      "mentorluk":"MENTORLUK",
      "signOut":"ÇIKIŞ",
      "welcome":"HOŞGELDİNİZ",
      "calismalar":"ÇALIŞMALAR",
      "kadinUzmanlarVeriTabaniText":"Kadın uzmanlar veri tabanına üye olmak ister misiniz?",
      "uzmanlarArasinaKatilin":"UZMANLAR ARASINA KATILIN",
      "uzmanArayin":"UZMAN ARAYIN",
      "kadinUzmanVeriTabani":"KADIN UZMAN VERİ TABANI",
      "medyaEgitimleri":"MEDYA EĞİTİMLERİ",
      "mentorlukCalismalari":"MENTORLUK ÇALIŞMALARI",
      "sessizOlmazBlog":"SESSİZ OLMAZ BLOG",
      "soruMesajlar":"Soru ve mesajlarınızı e-posta yoluyla bize iletebilirsiniz.",
      "sıkSorulanSorular":"Sık Sorulan Sorular",
      "herHakkiSaklidir":"Her hakkı saklıdır.",
      "kadinUzman":"KADIN UZMAN",
      "veriTabani":"VERİ TABANI",
      "calismalari":"ÇALIŞMALARI",
      "mentoring":"MENTORLUK",
      "farkindalik":"FARKINDALIK",
      "sosoCalismalari":"ÇALIŞMALAR",
      "mentorship":"MENTORLUK",
      "aramaKriterleri":"ARAMA KRİTERLERİ",
      "aradiginizBulunamadiTekrarDene":"Aradığınız kriterlerde uzman bulunamadı. Lütfen tekrar deneyiniz.",
      "iletisimBilgileri":"İletişim Bilgileri",
      "yukleniyor":"Yükleniyor",
      "uzmanBilgileri":"Uzman Bilgileri",
      "calistigiKurum":"Çalıştığı Kurum",
      "belirtilmemis": "Belirtilmemiş",
      "bagimsizCalisiyor":"Bağımsız Çalışıyor",
      "medyaDeneyimi":"Medya Deneyimi",
      "var":"Var",
      "yok":"Yok",
      "konferansDeneyimi":"Konferans Deneyimi",
      "kisaOzgecmis":"Kısa Özgeçmiş",
      "calistigiSektor":"Çalıştığı Sektör",
      "uzmanlikAlanlari":"Uzmanlık Alanları",
      "yayinVeReferanslar":"Yayın ve Referanslar",
      "sosyalMedyaHesaplari":"Sosyal Medya Hesapları",
      "projeEkibi":"PROJE EKİBİ",
      "toplantiResim1":"Lansman toplantısı katılımcıları Miranda Holt'u dinliyor.",
      "toplantiResim2":"Seda Demiralp Sensiz Olmaz Sessiz Olmaz’ın sağladığı medya eğitimi hakkında görüşlerini paylaşıyor.",
      "toplantiResim3":"Proje ekibinden Semin Gümüşel Güner ve Özge Genç Sensiz Olmaz Sessiz Olmaz projesiyle ilgili bilgi veriyor.",
      "toplantiResim4":"Medyada Kadın Temsili: Engelleri Aşmak, Çözümler Üretmek, 24 Kasım 2023, Istanbul",
      "egitimResim1":"Galatasaray Üniversitesi MEDİAR işbirliğiyle kadın uzmanlarla gerçekleştirilen medya eğitimi. / 16 Ocak 2023",
      "egitimResim2":"Bahçeşehir Üniversitesi’nden kadın uzmanlarla BAU EQUAL işbirliğiyle gerçekleştirilen medya eğitimi. / 7-8 Nisan 2023",
      "egitimResim3":"Sensiz Olmaz Sessiz Olmaz veri tabanı üyelerine yönelik online medya eğitimi",
      "epostaAdresi":"E-Posta Adresi",
      "sifre":"Şifre",
      "hesabinizYokmu":"Hesabınız Yok mu ?",
      "sifremiUnuttum":"Şifremi Unuttum",
      "kayitOl":"Kayıt Ol",
      "girisYap":"GİRİŞ YAP",
      "lutfenEpostaAdresiniGiriniz":"Lütfen e-posta adresinizi giriniz.",
      "sifreniziGiriniz":"Şifrenizi giriniz.",
      "basariylaCikisYapildi":"Başarıyla çıkış yapıldı.",
      "lutfenEpostaAdresiniKontrolEdin":"Lütfen e-posta adresinizi kontrol edin.",
      "lutfenSifreAlaniniKontrolEdin":"Lütfen şifre alanını kontrol edin.",
      "girisYapildi":"Giriş Yapıldı",
      "kullaniciAdiVeyaSifreKontrol":"Lütfen kullanıcı adı veya şifrenizi kontrol edin.",
      "turkce":"Türkçe",
      "english":"English",
      "anErrorHasOccured":"Bir hata oluştu. Lütfen tekrar deneyiniz.",
      "resetPasswordLinkSent":"Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.",
      "lutfenMedyaHesabiIcinCikisYapiniz":"Lütfen medya hesabı ile giriş yapmak için önce çıkış yapınız.",
      "medyaGiris":"Medya - Giriş",
      "giris":"Giriş",
      "yada":"yada",
      "girisYapKucuk":"Giriş Yap",
      "gonder":"Gönder",
      "cikis" : "Çıkış",
      "lutfenBirUzmanSecin":"Lütfen bir uzman seçin",
      "mesajGonder":"Mesaj Gönder",
      "uzmanOlduguUlkeler":"Uzman Olduğu Ülkeler",
      "gorusVermekIstedigiKonular":"Görüş Vermek İstediği Konular",
      "merhaba":"Merhaba",
      "baslangicAciklama":"Sensiz Olmaz Sessiz Olmaz veri tabanına aşağıdaki adımları takip ederek kolayca kaydolabilirsiniz.",
      "adim1Title":"Adım 1",
      "adim1Text":"Adınızı ve e-mailinizi kaydettikten sonra profilinizde görünecek bir fotoğraf eklemeniz gerekecek.",
      "adim2Title":"Adım 2",
      "adim2Text":"Çalıştığınız Sektör listesinden çalışmalarınızı hangi sektör içerisinde yürüttüğünüzü belirleyebilirsiniz. Aynı sayfa içerisinde Uzmanlık Alanlarınız başlığı altında çalışma alanlarınıza dair bilgi verebilirsiniz. Çalışma alanlarınızı tanımlayan anahtar kelimeleri yazarken detay verebileceğinizi hatırlatmak isteriz. Burada gireceğiz anahtar kelimeler, veri tabanında aratıldığında size daha kolay ulaşılmasını sağlayacak.",
      "adim3Title":"Adım 3",
      "adim3Text":"Bu adımda, çalıştığınız kurumu belirtmeniz istenecek. Aynı zamanda 'Bağımsız Çalışıyorum' seçeneği de mevcut. Sonrasında özgeçmişinizi bir dosya olarak yükleyebileceğiniz gibi varsa LinkedIn hesabınızın bağlantısını da kopyalayabilirsiniz. Belirtmek isterseniz yaşadığınız ülke ve şehri de bu adımda seçebilirsiniz.",
      "adim4Title":"Adım 4",
      "adim4Text":"Medya ve/veya konferans deneyimlerinizi profilinizde görünmesini istediğiniz ilgili video ve yayınları da ekleyerek son adıma geçebilirsiniz.",
      "adim5Title":"Adım 5",
      "adim5Text":"Bu adımda, ilgili kurum çalışanlarının sizin ile nasıl iletişime geçeceğini belirleyeceksiniz. Telefon ve e-posta adreslerinizin profilinizde görünmesi onayınıza sunulacak. Varsa sosyal medya hesaplarınızı profilinize ekleyebilirsiniz. Son olarak, Aydınlatma Metni ve Ön Bilgilendirme Formu'nu okumanızı özellikle rica ederiz. Dikkatlice okuyup onayladıktan sonra 'Tamamla' butonuna tıklayıp profilinizi oluşturabilirsiniz.",
      "hosgeldiniz" : "Hoş geldiniz",
      "basla" : "BAŞLA",
      "medyaKayitFormu":"Medya Kayıt Formu",
      "lutfenAdiniziveSoyadinizAlani":"Lütfen Adınız / Soyadınız alanını kontrol edin.",
      "lutfenGecerliEmailAdresiGiriniz":"Lütfen geçerli bir e-posta adresi girin.",
      "lutfenUzmanlikAlanlariniziBelirtiniz":"Lütfen uzmanlık alanlarınızı belirtiniz.",
      "lutfenCalistiginizSektoruSeciniz":"Lütfen çalıştığınız sektörü seçiniz.",
      "lutfenKisaOzgecmisGiriniz":"Lütfen kısa özgeçmiş giriniz.",
      "lutfenYasadiginizUlkeyiSeciniz":"Lütfen yaşadığınız ülkeyi seçiniz.",
      "lutfenYasadiginizSehriSeciniz":"Lütfen yaşadığınız şehri seçiniz.",
      "lutfenTelefonNumarasiGiriniz":"Lütfen telefon numarası giriniz.",
      "lutfenOnBilgilendirmeFormunuOnaylayin":"Lütfen ön bilgilendirme formunu onaylayın.",
      "katilimciBilgiFormuBasariylaGonderildi":"Katılımcı bilgi formu başarıyla gönderildi.",
      "kayitliKullanici":"Bu isim ile daha önceden kayıt oluşturulmuş. Lütfen tekrar deneyiniz.",
      "kayitEsnasindaHata":"Kayıt esnasında bir hata oluştu. Lütfen tekrar deneyiniz.",
      "kayitEpostaAdresiniKontolEdiniz":"Kayıt e-posta adresini kontrol ediniz.",
      "tamamla":"TAMAMLA",
      "ileri":"İLERİ",
      "geri":"GERİ",
      "kaydet":"KAYDET",
      "katilimciBilgiFormu":"Katılımcı Bilgi Formu",
      "birinciAdim":"1. ADIM",
      "ikinciAdim":"2. ADIM",
      "ucuncuAdim":"3. ADIM",
      "dorduncuAdim":"4. ADIM",
      "besinciAdim":"5. ADIM",
      "resimYuklendi":"Resim yüklendi",
      "resimKaldirildi":"Resim kaldırıldı",
      "fotografiniz":"Fotoğrafınız",
      "yukle":"YÜKLE",
      "tamam":"Tamam",
      "iptal":"İptal", 
      "resimDuzenle":"Resim Düzenle",
      "resimYukle":"Resim Yükle",
      "adinizSoyadiniz":"Adınız / Soyadınız",
      "lutfenTamAdiniziGiriniz":"Lütfen tam adınızı giriniz.",
      "kayitEpostaAdresi":"Kayıt E-Posta Adresi",
      "lutfenKonuBasliginiKontrolEdin":"Lütfen konu başlığını kontrol edin.",
      "calistiginizSektor":"Çalıştığınız Sektör",
      "uzmanlikAlanlariniz":"Uzmanlık Alanlarınız",
      "calistiginizKurum":"Çalıştığınız Kurum",
      "lutfenTamAdiniGiriniz":"Lütfen tam adını giriniz.",
      "bagimsizCalisiyorum":"Bağımsız Çalışıyorum",
      "kisaOzgecmisiniz":"Kısa Özgeçmişiniz",
      "yasadiginizUlkeSehir":"Yaşadığınız Ülke / Şehir",
      "yazarakFiltreleyin":"yazarak filtreleyin",
      "lutfenUlkeSeciniz":"Lütfen ülke seçiniz.",
      "lutfenSehirGiriniz":"Lütfen şehir giriniz.",
      "lutfenGecerliBirBaglantiGirin":"Lütfen geçerli bir bağlantı girin.",
      "medyaDeneyiminizVarMi":"Medya deneyiminiz var mı?",
      "konferansDeneyiminizVarMi":"Konferans deneyiminiz var mı?",
      "ilgiliYayinVeReferansBaglantilari":"İlgili yayın ve referans bağlantıları",
      "yayinYoutube":"Buraya yayın, youtube",
      "baglantisiEkleyebilirsiniz":"bağlantısı ekleyebilirsiniz.",
      "baglantiAdresiGirin":"Bağlantı adresi girin",
      "ekle":"Ekle",
      "sosyalMedyaHesaplariniz":"Sosyal Medya Hesaplarınız",
      "hesapAdi":"Hesap adı",
      "iletisimBilgileriniz":"İletişim Bilgileriniz",
      "profilimdeGorunsun":"Profilimde Görünsün",
      "telefonNumaraniziGiriniz":"Telefon numaranızı giriniz",
      "epostaAdresiniziGiriniz":"E-posta adresinizi giriniz",
      "aydinlantmaMetniOnBilgilendirmeFormu":"Aydınlatma Metni ve Ön Bilgilendirme Formu 'nu okudum onaylıyorum.",
      "isleminizBasariylaGerceklesmistir":"İşleminiz başarıyla gerçekleşmiştir.",
      "basariMesaj1":"Birkaç dakika içinde e-mail adresinize gönderilecek aktivasyon mesajındaki linke tıklayarak profilinizi doğrulayabilirsiniz.",  
      "basariMesaj2":"Gün içinde tarafınıza ayrıca bir onay mesajı gönderilecek, profiliniz sitede yayımlanmaya başlayacaktır.",
      "programs":"Programları",
      "campaigns":"ÇALIŞMALARI",
      "lutfenSecimYapiniz":"Lütfen seçim yapınız",
      "lutfenKisaAciklamaGiriniz":"Lütfen kısa açıklama giriniz",
      "profilGuncellendi":"Profil Güncellendi",
      "lutfenSifreAlanlariniKontrolEdiniz":"Lütfen şifre alanlarını kontrol ediniz.", 
      "sifreAlanlariAyniDegil":"Şifre alanları aynı değil.",
      "sifreEnAzBesKarakter":"Şifre en az 5 karakter olmalıdır.",
      "sifreGuncellendiTekrarGirisYapiniz":"Şifre güncellendi. Lütfen tekrar giriş yapınız.",
      "bilgilerimiGuncelle":"BİLGİLERİMİ GÜNCELLE",
      "sifreDegistir":"Şifre Değiştir",
      "newPassword":"Yeni Şifre",
      "reNewPassword":"Yeni Şifre Tekrar",
      "lutfenYeniSifreniziGiriniz":"Lütfen yeni şifrenizi giriniz.",
      "lutfenYeniSifreniziTekrarGiriniz":"Lütfen yeni şifrenizi tekrar giriniz.",
      "sifreGuncelle":"ŞİFRE GÜNCELLE",
      "profilBilgileriniz":"Profil Bilgileriniz",
      "yasadiginizUlke":"Yaşadığınız Ülke",
      "yasadiginizSehir":"Yaşadığınız Şehir",
      "sadeceHesapAdiniYazin":"Sadece hesap adını yazınız. Örn. Twitter için sensizolmazorg",
      "durum":"Durum",
      "aktif":"Aktif",
      "pasif":"Pasif",
      "telefon":"Telefon",
      "lutfenWebsitesiGiriniz":"Lütfen websitesi giriniz",
      "kisaAciklama":"Kısa Açıklama",
      "websitesi":"Websitesi",
      "profilimiGuncelle":"PROFİLİMİ GÜNCELLE",
      "yanlisAramaKriteri":"Yanlış arama kriteri. Lütfen tekrar deneyiniz.",
      "aramaKriteriBosOlamaz":"Arama kriteri boş olamaz.",


      
    },
    "routes": {
      "home": "/anasayfa",
      "signup": "/kayitol",
      "faq": "/sss",
      "blog": "/blog",
      "aboutUs": "/hakkimizda",
      "educations": "/egitimler",
      "contactUs": "/iletisim",
      "meetings": "/toplantilar",
      "awarenessCampaigns": "/farkindalik-calismalari",
      "mentoring": "/mentorluk",
      "findExpert": "/uzman-bul",
      "expert": "/uzman/:eid/:ename",
      "cv": "/ozgecmisler/:people",
      "cvs": "/ozgecmisler",
      "introVideo": "/tanitim-filmi",
      "searchResults": "/arama-sonuclari",
      "login": "/giris",
      "forgotPassword": "/sifremi-unuttum",
      "profile": "/profil",
      "passwordReset": "/sifre-resetle",
      "mediaSignup": "/medya-kayit",
      "baslangic":"/baslangic",
      "baslangicMedya":"/baslangicmedya",
      "kayitFormu":"/kayit-formu",
      

    },
    "metas":{
      "title":"Sensiz Olmaz Sessiz Olmaz",
      "description":"Sensiz Olmaz Sessiz Olmaz platformu, televizyon, gazete, çevrimiçi haber sitelerinin yanı sıra sivil toplum ve özel sektör toplantılarında da kadın uzmanlara dengeli bir şekilde yer verilmesini sağlamak üzere farklı disiplinlerden kadın uzmanların profillerinden oluşan bir veri tabanı sunuyor ve sürekli olarak güncellenen bu veri tabanı ile editör, gazeteci, televizyon yapımcısı, organizatör ve ilgili tüm paydaşların alanlarında uzman kadınlara kolaylıkla erişebilmesini sağlıyor.",
      "twitter":{
        "title":"Sensiz Olmaz Sessiz Olmaz",
        "description":"Sensiz Olmaz Sessiz Olmaz platformu, televizyon, gazete, çevrimiçi haber sitelerinin yanı sıra sivil toplum ve özel sektör toplantılarında da kadın uzmanlara dengeli bir şekilde yer verilmesini sağlamak üzere farklı disiplinlerden kadın uzmanların profillerinden oluşan bir veri tabanı sunuyor ve sürekli olarak güncellenen bu veri tabanı ile editör, gazeteci, televizyon yapımcısı, organizatör ve ilgili tüm paydaşların alanlarında uzman kadınlara kolaylıkla erişebilmesini sağlıyor.",
      },
      "og":{
        "title":"Sensiz Olmaz Sessiz Olmaz",
        "description":"Sensiz Olmaz Sessiz Olmaz platformu, televizyon, gazete, çevrimiçi haber sitelerinin yanı sıra sivil toplum ve özel sektör toplantılarında da kadın uzmanlara dengeli bir şekilde yer verilmesini sağlamak üzere farklı disiplinlerden kadın uzmanların profillerinden oluşan bir veri tabanı sunuyor ve sürekli olarak güncellenen bu veri tabanı ile editör, gazeteci, televizyon yapımcısı, organizatör ve ilgili tüm paydaşların alanlarında uzman kadınlara kolaylıkla erişebilmesini sağlıyor."
      }
    }
  },
  "EN":{
    "name":"English",
    "alias":"english",
    "short":"EN",
    "keywords": {
      "home":"HOMEPAGE",
      "aboutUs":"ABOUT US",
      "findExpert":"FIND AN EXPERT",
      "ourEducations":"OUR TRAININGS",
      "articles":"BLOG",
      "contactUs":"CONTACT",
      "signIn":"LOGIN",
      "signUp":"SIGNUP",
      "keyword":"Keyword",
      "sector":"Sector",
      "profession":"Profession",
      "regionOfInterest":"Region of Interest",
      "language":"Language",
      "wantToJoinToOurExperts":"Would you like to join our experts?",
      "slogan1":"Be the one so that the media's voice is full",
      "watchPromotionVideo":"Watch the promotional video",
      "wantToRecommendExpert":"Would you like to recommend an expert?",
      "findWomanExpert":"Find a Woman Expert",
      "pleaseSelectSector":"Please select a sector",
      "pleaseSelectProfession":"Please select a profession",
      "pleaseSelectRegion":"Please select a region",
      "pleaseSelectLanguage":"Please select a language",
      "upcomingEducations":"Upcoming Educations",
      "upcoming":"Upcoming",
      "educations":"Trainings",
      "featured":"Featured",
      "lastJoined":"Last Joined",
      "experts":"Experts",
      "lastJoinedExperts":"Last Joined Experts",
      "getInTouch":"Contact Us",
      "recent":"Recent",
      "posts":"Shares",
      "ourSponsors":"Our sponsors",
      "ourSupporters":"Our supporters",
      "profile":"PROFILE",
      "messages":"MESSAGES",
      "egitimler":"TRAININGS",
      "toplantilar":"MEETINGS",
      "farkindalikCalismalari":"AWARENESS RAISING",
      "mentorluk":"MENTORSHIP",
      "signOut":"SIGN OUT",
      "welcome":"WELCOME",
      "calismalar":"PROJECTS",
      "kadinUzmanlarVeriTabaniText":"Would you like to become a member of the database of female experts?",
      "uzmanlarArasinaKatilin":"JOIN THE EXPERTS",
      "uzmanArayin":"SEARCH FOR AN EXPERT",
      "kadinUzmanVeriTabani":"WOMAN EXPERT DATABASE",
      "medyaEgitimleri":"MEDIA TRAININGS",
      "mentorlukCalismalari":"MENTORING STUDIES",
      "sessizOlmazBlog":"SENSIZ OLMAZ SESSIZ OLMAZ BLOG",
      "soruMesajlar":"You can send us your questions and messages via e-mail.",
      "sıkSorulanSorular":"Frequently Asked Questions",
      "herHakkiSaklidir":"All rights reserved.",
      "kadinUzman":"WOMAN EXPERT",
      "veriTabani":"DATABASE",
      "calismalari":"PROGRAMS",
      "mentoring":"MENTORING",
      "farkindalik":"AWARENESS",
      "sosoCalismalari":"Not Without You Not Without Your Voice Initiatives",
      "mentorship":"MENTORSHIP",
      "aramaKriterleri":"SEARCH CRITERIA",
      "aradiginizBulunamadiTekrarDene":"No experts were found matching your search criteria. Please try again.",
      "iletisimBilgileri":"Contact information",
      "yukleniyor":"Loading",
      "uzmanBilgileri":"Expert Information",
      "calistigiKurum":"Institution she is working at",
      "belirtilmemis": "Unspecified",
      "bagimsizCalisiyor":"Working freelance",
      "medyaDeneyimi":"Media Experience",
      "var":"Available",
      "yok":"Not Available",
      "konferansDeneyimi":"Conference Experience",
      "kisaOzgecmis":"Short CV",
      "calistigiSektor":"Sector in which she works",
      "uzmanlikAlanlari":"Areas of expertise",
      "yayinVeReferanslar":"Publications and References",
      "sosyalMedyaHesaplari":"Social Media Accounts",
      "projeEkibi":"PROJECT TEAM",
      "toplantiResim1":"Launch meeting attendees listen to Miranda Holt.",
      "toplantiResim2":"Seda Demiralp shares her views on the media training provided by Women Voices.",
      "toplantiResim3":"Semin Gümüşel Güner and Özge Genç, members of the project team, give information about the project 'Women Voices'.",            
      "toplantiResim4":"Representation of Women in the Media: Overcoming Barriers, Generating Solutions, November 24, 2023, Istanbul",            
      "egitimResim1":"Media training conducted with female experts in cooperation with Galatasaray University MEDIAR. / January 16, 2023",
      "egitimResim2":"Media training carried out in cooperation with female experts from Bahçeşehir University and BAU EQUAL. / 7-8 April 2023",
      "egitimResim3":"Online media training for Women Voices database members",
      "epostaAdresi":"Email Address",
      "sifre":"Password",
      "hesabinizYokmu":"Don't have an account?",
      "sifremiUnuttum":"Forgot password",
      "kayitOl":"Sign Up",
      "girisYap":"SIGN IN",
      "lutfenEpostaAdresiniGiriniz":"Please enter your email address.",
      "sifreniziGiriniz":"Enter your password.",
      "basariylaCikisYapildi":"Successfully signed out.",
      "lutfenEpostaAdresiniKontrolEdin":"Please check the email address.",
      "lutfenSifreAlaniniKontrolEdin":"Please check the password.",
      "girisYapildi":"Successfully signed in",
      "kullaniciAdiVeyaSifreKontrol":"Please check the username or password.",
      "turkce":"Türkçe",
      "english":"English",
      "anErrorHasOccured":"An error occurred. Please try again.",
      "resetPasswordLinkSent":"A password reset link has been sent to your email address.",
      "lutfenMedyaHesabiIcinCikisYapiniz":"Please sign out to log in with a media account.",
      "medyaGiris":"Media - Login",
      "giris":"Sign In",
      "yada":"or",
      "girisYapKucuk":"Sign In",
      "gonder":"Submit",
      "cikis" : "Sign Out",
      "lutfenBirUzmanSecin":"Please select an expert",
      "mesajGonder":"Send Message",
      "uzmanOlduguUlkeler":"Countries of Expertise",
      "gorusVermekIstedigiKonular":"Topics of Interest",
      "merhaba":"Hello",
      "baslangicAciklama":"You can easily register in the Sensiz Olmaz Sessiz Olmaz database by following the steps below.",
      "adim1Title":"Step 1",
      "adim1Text":"After entering your name and email, you will need to upload a photo that will appear on your profile.",
      "adim2Title":"Step 2",
      "adim2Text":"You can specify the sector in which you work by selecting from the Industry list. On the same page, under the Areas of Expertise section, you can provide information about your fields of work. We encourage you to include detailed keywords that describe your work areas. These keywords will make it easier for others to find you in the database.",
      "adim3Title":"Step 3",
      "adim3Text":"At this step, you will be asked to specify the institution you work for. There is also an option to select I work independently. You can upload your resume as a file or paste the link to your LinkedIn profile if you have one. Additionally, you may choose to indicate the country and city where you live.",
      "adim4Title":"Step 4",
      "adim4Text":"If you wish, you can add relevant videos and publications showcasing your media and/or conference experiences before proceeding to the final step.",
      "adim5Title":"Step 5",
      "adim5Text":"In this step, you will determine how relevant institutions can contact you. You will be asked for permission to display your phone number and email address on your profile. If you have social media accounts, you can add them to your profile. Finally, we kindly ask you to read the Privacy Notice and Pre-Information Form carefully. Once you have read and approved them, click the Complete button to finalize your profile.",
      "hosgeldiniz" : "Welcome",
      "basla" : "START",
      "medyaKayitFormu":"Media Registration Form",
      "lutfenAdiniziveSoyadinizAlani":"Please check the Name / Surname field.",
      "lutfenGecerliEmailAdresiGiriniz":"Please enter a valid email address.",
      "lutfenUzmanlikAlanlariniziBelirtiniz":"Please specify your areas of expertise.",
      "lutfenCalistiginizSektoruSeciniz":"Please select the sector you work in.",
      "lutfenKisaOzgecmisGiriniz":"Please enter a short CV.",
      "lutfenYasadiginizUlkeyiSeciniz":"Please select the country you live in.",
      "lutfenYasadiginizSehriSeciniz":"Please select the city you live in.",
      "lutfenTelefonNumarasiGiriniz":"Please enter your phone number.",
      "lutfenOnBilgilendirmeFormunuOnaylayin":"Please approve the pre-information form.",
      "katilimciBilgiFormuBasariylaGonderildi":"Participant information form has been successfully sent.",
      "kayitliKullanici":"A registration has already been created with this name. Please try again.",
      "kayitEsnasindaHata":"An error occurred during registration. Please try again.",
      "kayitEpostaAdresiniKontolEdiniz":"Check the email address during registration.",
      "tamamla":"COMPLETE",
      "ileri":"NEXT",
      "geri":"BACK",
      "kaydet":"SAVE",
      "katilimciBilgiFormu":"Participant Information Form",
      "birinciAdim":"1. STEP",
      "ikinciAdim":"2. STEP",
      "ucuncuAdim":"3. STEP",
      "dorduncuAdim":"4. STEP",
      "besinciAdim":"5. STEP",
      "resimYuklendi":"Image uploaded",
      "resimKaldirildi":"Image removed",
      "fotografiniz":"Your Photo",
      "yukle":"UPLOAD",
      "tamam":"OK",
      "iptal":"Cancel", 
      "resimDuzenle":"Edit Image",
      "resimYukle":"Upload Image",
      "adinizSoyadiniz":"Name / Surname",
      "lutfenTamAdiniziGiriniz":"Please enter your full name.",
      "kayitEpostaAdresi":"Registration Email Address",
      "lutfenKonuBasliginiKontrolEdin":"Please check the subject title.",
      "calistiginizSektor":"Sector in which you work",
      "uzmanlikAlanlariniz":"Areas of expertise",
      "calistiginizKurum":"Institution you work for",
      "lutfenTamAdiniGiriniz":"Please enter full name.",
      "bagimsizCalisiyorum":"I work independently",
      "kisaOzgecmisiniz":"Your Short CV",
      "yasadiginizUlkeSehir":"Country / City You Live In",
      "yazarakFiltreleyin":"Filter by typing",
      "lutfenUlkeSeciniz":"Please select a country.",
      "lutfenSehirGiriniz":"Please enter a city.",
      "lutfenGecerliBirBaglantiGirin":"Please enter a valid link.",
      "medyaDeneyiminizVarMi":"Do you have media experience?",
      "konferansDeneyiminizVarMi":"Do you have conference experience?",
      "ilgiliYayinVeReferansBaglantilari":"Relevant publications and references",
      "yayinYoutube":"You can add ",
      "baglantisiEkleyebilirsiniz":"publication link or youtube link.",
      "baglantiAdresiGirin":"Enter the link",
      "ekle":"Add",
      "sosyalMedyaHesaplariniz":"Your Social Media Accounts",
      "hesapAdi":"Account Name",
      "iletisimBilgileriniz":"Your Contact Information",
      "profilimdeGorunsun":"Show on my profile",
      "telefonNumaraniziGiriniz":"Enter your phone number",
      "epostaAdresiniziGiriniz":"Enter your email address",
      "aydinlantmaMetniOnBilgilendirmeFormu":"I have read and approved the Privacy Notice and Pre-Information Form.",
      "isleminizBasariylaGerceklesmistir":"Your transaction has been successfully completed.",
      "basariMesaj1":"An activation message will be sent to your email address in a few minutes. By clicking on the link in the email, you can verify your profile.",  
      "basariMesaj2":"An approval message will be sent to you later in the day, and your profile will be published on the site.",
      "programs":"Programs",   
      "campaigns":"CAMPAIGNS", 
      "lutfenSecimYapiniz":"Please make a selection",
      "lutfenKisaAciklamaGiriniz":"Please enter a brief description",
      "profilGuncellendi":"Profil Updated",
      "lutfenSifreAlanlariniKontrolEdiniz":"Please check the password fields.", 
      "sifreAlanlariAyniDegil":"The password fields are not the same.",
      "sifreEnAzBesKarakter":"The password must be at least 5 characters.",
      "sifreGuncellendiTekrarGirisYapiniz":"The password has been updated. Please log in again.",
      "bilgilerimiGuncelle":"UPDATE MY INFORMATION",
      "sifreDegistir":"Change Password",
      "newPassword":"New Password",
      "reNewPassword":"New Password Again",
      "lutfenYeniSifreniziGiriniz":"Please enter your new password.",
      "lutfenYeniSifreniziTekrarGiriniz":"Please enter your new password again.",
      "sifreGuncelle":"UPDATE PASSWORD",
      "profilBilgileriniz":"Your Profile Information",
      "yasadiginizUlke":"Country You Live In",
      "yasadiginizSehir":"City You Live In",
      "sadeceHesapAdiniYazin":"Just write the account name. Eg. For Twitter, sensizolmazorg",
      "durum":"Status",
      "aktif":"Active",
      "pasif":"Passive",
      "telefon":"Phone",
      "lutfenWebsitesiGiriniz":"Please enter the website",
      "kisaAciklama":"Short Description",
      "websitesi":"Website",
      "profilimiGuncelle":"UPDATE MY PROFILE", 
      "yanlisAramaKriteri":"Incorrect search criteria. Please try again.",
      "aramaKriteriBosOlamaz":"Search criteria cannot be empty.",           
    },
    "routes": {
      "home": "/home",
      "signup": "/signup",
      "faq": "/faq",
      "blog": "/blog",
      "aboutUs": "/aboutus",
      "educations": "/trainings",
      "contactUs": "/contact",
      "meetings": "/meetings",
      "awarenessCampaigns": "/awareness-campaigns",
      "mentoring": "/mentoring",
      "findExpert": "/find-expert",
      "expert": "/expert/:eid/:ename",
      "cv": "/cv/:people",
      "cvs": "/cvs",
      "introVideo": "/intro-video",
      "searchResults": "/search-results",
      "login": "/login",
      "forgotPassword": "/forgot-password",
      "profile": "/profile",
      "passwordReset": "/password-reset",
      "mediaSignup": "/media-signup",
      "baslangic":"/start",
      "baslangicMedya":"/baslangicmedya",
      "kayitFormu":"/signup-form"
    },
    "metas":{
      "title":"Women Voices",
      "description":"The Women Voices platform offers a database of profiles of women experts from various disciplines to ensure balanced representation of women experts in television, newspapers, online news sites, as well as civil society and private sector meetings. This continuously updated database allows editors, journalists, television producers, organizers, and all relevant stakeholders to easily access women experts in their fields.",
      "twitter":{
        "title":"Women Voices",
        "description":"The Women Voices platform offers a database of profiles of women experts from various disciplines to ensure balanced representation of women experts in television, newspapers, online news sites, as well as civil society and private sector meetings. This continuously updated database allows editors, journalists, television producers, organizers, and all relevant stakeholders to easily access women experts in their fields.",
      },
      "og":{
        "title":"Women Voices",
        "description":"The Women Voices platform offers a database of profiles of women experts from various disciplines to ensure balanced representation of women experts in television, newspapers, online news sites, as well as civil society and private sector meetings. This continuously updated database allows editors, journalists, television producers, organizers, and all relevant stakeholders to easily access women experts in their fields."
      }
    }    
  }  
}